/**
 * 图片URL处理工具
 */

/**
 * 获取完整的图片URL
 * @param {string} imagePath - 相对路径或完整URL
 * @returns {string} 完整的HTTPS URL
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  
  // 如果已经是完整URL，直接返回
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    // 如果是HTTP URL，转换为HTTPS
    if (imagePath.startsWith('http://')) {
      return imagePath.replace('http://', 'https://');
    }
    return imagePath;
  }
  
  // 如果是相对路径，构建完整的HTTPS URL
  const baseUrl = window.location.protocol === 'https:' 
    ? `https://${window.location.host}`
    : `http://${window.location.host}`;
    
  // 确保路径以/开头
  const path = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  
  return `${baseUrl}${path}`;
};

/**
 * 获取缩略图URL（如果需要的话）
 * @param {string} imagePath - 图片路径
 * @param {string} size - 缩略图尺寸，如 '200x200'
 * @returns {string} 缩略图URL
 */
export const getThumbnailUrl = (imagePath, _size = '200x200') => {
  const fullUrl = getImageUrl(imagePath);
  // 这里可以根据需要添加缩略图逻辑
  return fullUrl;
};

/**
 * 处理图片加载错误的默认图片
 */
export const DEFAULT_IMAGE = '/images/default-product.png';

/**
 * 图片加载错误处理
 * @param {Event} event - 图片加载错误事件
 */
export const handleImageError = (event) => {
  event.target.src = getImageUrl(DEFAULT_IMAGE);
  event.target.onerror = null; // 防止循环错误
}; 